import Link from '@pelckmans/elementis/components/link';
import { useTranslation } from 'react-i18next';
import { useRoutes } from '../../hooks/useRoutes';

const BASE = 'APP_NAV.FOOTER';

function Footer() {
  const { t } = useTranslation();
  const { getRoute } = useRoutes();

  return (
    <footer className="footer">
      <div className="footer-content__text">{t(`${BASE}.DISCLAIMER`)}</div>
      <ul className="footer-content__links">
        <li className="footer-content__links__link">
          <Link size="sm" prominence="neutral" to={`/ianua/${getRoute('HELP')}`}>
            {t(`${BASE}.LINKS.INFO`)}
          </Link>
        </li>
        <li className="footer-content__links__link">
          <Link size="sm" prominence="neutral" to={`/ianua/${getRoute('TERMS_AND_CONDITIONS')}`}>
            {t(`${BASE}.LINKS.TERMS`)}
          </Link>
        </li>
        <li className="footer-content__links__link">
          <Link size="sm" prominence="neutral" to={`/ianua/${getRoute('PRIVACY_POLICY')}`}>
            {t(`${BASE}.LINKS.PRIVACY`)}
          </Link>
        </li>
      </ul>
    </footer>
  );
}

export default Footer;
